import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentUser: null,
  loading: false,
  error: false,
  message: "",
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    loginStart: (state) => {
      state.loading = true;
    },
    loginSuccess: (state, action) => {
      state.currentUser = action.payload;
      state.loading = false;
      state.error = false;
    },
    loginFailure: (state, action) => {
      state.loading = false;
      state.error = true;
      state.message = action.payload.data;
    },

    RegisterStart: (state) => {
      state.loading = true;
    },
    RegisterSuccess: (state, action) => {
      state.currentUser = action.payload;
      state.loading = false;
      state.error = false;
    },
    RegisterFailure: (state) => {
      state.loading = false;
      state.error = false;
    },

    logout: (state) => {
      state.currentUser = null;
      state.loading = false;
      state.error = false;
    },
    subscribe: (state, action) => {
      if (!state.currentUser?.subscribersUsers.includes(action.payload)) {
        state.currentUser?.subscribersUsers.push(action.payload);
        // state.currentUser?.subscribers + 1;
      } else {
        state.currentUser.subscribersUsers.splice(
          state.currentUser.subscribersUsers.findIndex(
            (channelId) => channelId === action.payload
          ),
          1
        );
        // state.currentUser?.subscribers - 1;
      }
    },
  },
});

export const {
  loginFailure,
  loginStart,
  loginSuccess,
  subscribe,
  logout,
  RegisterFailure,
  RegisterStart,
  RegisterSuccess,
} = userSlice.actions;
export default userSlice.reducer;
